<template>
  <div :class="{ 'my-box': speaker === 'my', 'other-box': speaker === 'other' }">
    <p
      class="message"
      :style="{
        background: speaker === 'my' ? color.balloonMy : color.balloonOtr + '!important',
        color: autoColor(speaker === 'my' ? color.balloonMy : color.balloonOtr),
        filter: shadowStyle(color.shadowType),
      }"
      v-html="
        $sanitize(convertMesasge(message, speaker === 'my' ? color.balloonMy : color.balloonOtr))
      "
      v-if="!isDemo || !isDemoEditScenario || speaker === 'my'"
    ></p>
    <textarea
      class="textarea message-title"
      :value="
        $sanitize(
          convertMesasge(originalMessage, speaker === 'my' ? color.balloonMy : color.balloonOtr)
        )
      "
      @blur="
        oldValue = $sanitize(
          convertMesasge(originalMessage, speaker === 'my' ? color.balloonMy : color.balloonOtr)
        )
        updateMainMessage($event.target.value, oldValue, logIndex)
      "
      v-else-if="!isConfirm"
    >
    </textarea>
    <textarea
      disabled
      class="textarea message-title"
      :value="
        $sanitize(
          convertMesasge(originalMessage, speaker === 'my' ? color.balloonMy : color.balloonOtr)
        )
      "
      v-else
    >
    </textarea>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
// 外部関数
import { autoColor, shadowStyle, convertMesasge } from '@/functions/balloonFunc'

export default {
  name: 'MessageParts',
  props: ['message', 'speaker', 'color', 'logIndex', 'isDemo', 'isDemoEditScenario', 'scenarioID', 'isConfirm', 'roboArguments'],
  data() {
    return {
      oldValue: '',
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable']),
    originalMessage() {
      return this.scenarioTable.find((obj) => {
        return this.scenarioID == obj.beforenode
      }).mainmessage
    },
  },
  methods: {
    autoColor(c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle(t) {
      return shadowStyle(t)
    },
    /* XSSを防ぐためにタグが来たらerrorで返す */
    convertMesasge(m, c) {
      let color = hex2rgb(c)
      return convertMesasge(m, color, this.roboArguments)
    },
    updateMainMessage(value, oldValue, logIndex) {
      this.$emit('updateMainMessage', value, oldValue, logIndex)
    },
  },
}
</script>

<style scoped>
.message {
  text-align: left;
  padding: 12px 16px;  /* ①上下のpaddingを少し減らし、左右は維持 */
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 18px;  /* ②より丸みを持たせる */
  font-size: 95%;  /* ③fontsize up */
  line-height: 1.4;  /* ④読みやすさのために行間を調整 */
  white-space: pre-wrap;
  transition: 0.7s;
  margin-bottom: 8px;  /* ⑤メッセージ間の間隔を追加 */
}
.my-box {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/MessageParts.vue